// "Normal" Modulo (restricted to positive numbers)
// modulo(-1, 4) === 3
export function modulo(x: number, n: number) {
    return ((x % n) + n) % n;
}
